<template>
  <div class='clock font14' >
    <p class="gray" style="padding-bottom:.1rem" v-if='list.length>0'>左滑删除闹钟</p>
    <div  v-for="(item,i) in list" :key='i'>
    <van-swipe-cell left-width='70px'>
        <div class='times flex-between'>
          <div style="flex:0 0 80%" @click='getImei(2,item)'>
              <p class='time1'>{{item.clockTime}}</p>
              <p class='gray' v-if="item.clockWeek.length<7">
                周<template v-for='(obj,j) in item.clockWeek'><span v-if='j>0' :key='j'>/</span>{{weeks[obj]}}</template>
              </p>
              <p class='gray' v-else>每天</p>
          </div>
          <van-switch v-model="item.clockStatus" active-color="#0A59F7" inactive-color="#dcdee0" size="20px" @change='changeStatus(item)' />
        </div>
        <template #right>
            <div class="delectBtn"><van-icon name="delete-o" @click='getImei(3,item)' /></div>
            <!-- <van-button square text="删除" type="danger" class="delete-button" @click='getImei(3,item)'/> -->
        </template>
     </van-swipe-cell>
    </div>
    <div class="btnFixed" v-if="list.length<3"> 
          <img src="@/assets/img/equipment/clockAdd.png"  class="round"  @click="getImei(1)" />
    </div> 
    <div class='noData' v-if="text&&list.length==0"><div><img :src='require("@/assets/img/equipment/noClock.png")'><br />{{text}}</div></div>
  
 
  </div>
</template>
<script>
import {getAlarmClockList,modifyStatus,clockDelete} from "@/api/api.equipment";
  export default {
    data() {
      return {
        list:'',
        isLoading:false,
        weeks:['日','一','二','三','四','五','六'],
        text:'',
      }
    },
   created(){
     this.getList();
    },
    methods: {
       getList(){
         this.list=[];
         getAlarmClockList({
              studentId:this.loginUser.studentId
           }).then((data) => {
                if (data.result&&data.result.length>0) {
                    data.result.forEach(item=>{
                      item.clockStatus=item.clockStatus==1?true:false;
                      item.clockWeek=item.clockWeek.split('');
                    })
                    this.list=data.result;
                }else{
                  this.text='暂未设置闹钟';
                }
           })
       },
       getImei(type,item){
         if(type>1&&item.clockStatus){
              let option={
                success:(data)=>{
                  if(data.deviceStatus!==1){
                      this.$toast('设备离线，无法操作');
                      return false;
                    }
                }
              }
              this.getImeis(option);
         }
          if(type==3){//删除
            this.delectCon(item);
          }else if(type==2){//编辑
           this.gotoUrl('clockDetail',item);
          }else{
            this.isAdd=true;
            this.gotoUrl('clockDetail');
          }
      },
       changeStatus(item){
         modifyStatus({
           clockStatus:item.clockStatus?1:0,
           id:item.id,
           studentId:this.loginUser.studentId
         }).then(data=>{
           if(data.code=='00000'){
             this.$toast('操作成功');
           }else{
            this.getList();
           }
           
         })
       },
       delectCon(item){
         this.$dialog.confirm({
            title:'删除闹钟',
            message: '确定删除该闹钟吗？',
            confirmButtonText:'确定'
         }).then(() => {
              clockDelete({
                  id:item.id
              }).then((data) => {
                if (data && data.result) {
                   this.$toast('删除成功');
                   this.getList();
                }else{
                  this.$toast(data.message);
                }
              })
         }).catch(() => {
          // on cancel
         });
       },
       gotoLook(url){
         this.deviceStatus=this.deviceInfo.deviceStatus;
         if(this.deviceStatus!==1){
           this.$toast('设备离线，无法操作');
           return false;
         }
         this.gotoUrl(url);
       }
    },
  }
</script>
<style lang="scss" >
.clock{
  padding:.12rem;
  color:#333;
  .times{
    background:#fff;
    line-height: .22rem;
    color:#666;
    padding:.1rem .12rem;
    border-radius: 8px;
    margin-bottom: .1rem;
  }
  .time1{
    color:#333;
    font-size: .18rem;
    font-weight: 550;
  }
  .van-button{
    height: 100%;
  }

    .round{
      width: 0.48rem !important;
    }
    .delectBtn{
       width: .4rem;
       height: .4rem;
       background: #E84026;
       color:#fff;
       font-size: .2rem;
       border-radius:50%;
       display: flex;
       justify-content: center;
       align-items: center;
       margin-top:.1rem;
       margin-left: .15rem;
    }
}

</style>